import React from 'react';

export const ResaleStatusContext = React.createContext({
  isAnyResaleOpen: false,
  setIsAnyResaleOpen: () => {},
  closeAllResales: () => {},
  resaleName: null,
  setResaleName: () => {},
});
